import * as React from 'react'
import { FC } from 'react'

import { ManageAgreements } from '../widgets/ManageAgreements/ManageAgreements'
import { GainMoreCustomers } from '../widgets/GainMoreCustomers/GainMoreCustomers'
import { OverdueNextActionDates } from '../widgets/OverdueNextActionDates/OverdueNextActionDates'
import { SettingsPage } from '@sales-center/components'
import { useCompanyPageTitle } from '@user/features/CompanyIdentifier/hooks'
import { UpcomingFollowUps } from '../widgets/UpcomingFollowUps/UpcomingFollowUps'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { ClosedWonQueueSubmissions } from '../widgets/ClosedWonQueueSubmissions/ClosedWonQueueSubmissions'

export const DashboardGrid: FC = () => {
  const pageTitle = useCompanyPageTitle()

  return (
    <SettingsPage {...pageTitle} padding="20px">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <GainMoreCustomers />
        </Grid>

        <Grid item xs={12} md={4}>
          <UpcomingFollowUps />
          <Box mt={2}>
            <ManageAgreements />
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <OverdueNextActionDates />
          <Box mt={2}>
            <ClosedWonQueueSubmissions />
          </Box>
        </Grid>
      </Grid>
    </SettingsPage>
  )
}

DashboardGrid.displayName = 'DashboardGrid'
